import { useEffect } from "react";
import "./CopyContentPopup.scss";
import ModalContainer from "../ModalContainer";
import OrganizationsPickerTable from "../../utils/OrganizationsPickerTable";
import { useOrganizationPicker } from "../../../context/organizations-picker.context";

export default function CopyContentModal({
	open,
	setOpen,
	loadingData,
	selectedOrganizationType,
	onConfirm,
}) {
	const {
		setFilteredList,
		organizations,
		setFilterType,
		setFilterResellers,
		selectedEntity,
		setSelectedEntity,
	} = useOrganizationPicker();

	useEffect(() => {
		if (open) {
			setSelectedEntity([]);
			setFilteredList(organizations);
			setFilterType([]);
			setFilterResellers([]);
		}
	}, [open, organizations]);

	function handleConfirm() {
		const selectedEntityIds = selectedEntity.map((el) => el.organization_plans[0].id);
		onConfirm(selectedEntityIds);
	}

	useEffect(() => {
		if (open) {
			setSelectedEntity([]);
		}
	}, [open]);

	return (
		<ModalContainer isOpen={open} setIsOpen={setOpen}>
			<div className="main_modal_content copy_plan_popup">
				<button
					className="main_close"
					onClick={() => setOpen(false)}
					type="button"
					aria-label="Chiudi"
				>
					<span className="icon_10 default close icon_mask !bg-white"></span>
				</button>

				<div className="main_header_modal gap-1 grid">
					<span className="title">Enti di destinazioni contenuto</span>
					{!selectedOrganizationType?.organization_type?.is_master && (
						<div>
							<span className={"text-dark-50"}>
								Tipologia ente: {selectedOrganizationType?.organization_type?.name}
							</span>
						</div>
					)}
				</div>

				<div className={"main_body_modal"}>
					<OrganizationsPickerTable
						loadingData={loadingData}
						selectedOrganizationType={selectedOrganizationType}
					/>
				</div>

				<div className="main_footer_modal">
					<div className="right_content">
						{/* Main Cta */}
						<button onClick={handleConfirm} className="button fill success" type="button">
							Conferma
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
}
